import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { getType, isArray, isDate, isNumber, isObject, isString } from '../type';
export var MILLISECONDS_IN_DAY = 86400000;
export var getDaysInMonth = function getDaysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};
export var parseDate = function parseDate() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!isString(value)) {
    // eslint-disable-next-line no-console
    console.warn('parseDate error', value);
    return {};
  }

  var _value$split = value.split('.'),
      _value$split2 = _slicedToArray(_value$split, 3),
      day = _value$split2[0],
      month = _value$split2[1],
      year = _value$split2[2];

  day = +day;
  month = +month;
  year = +year;
  return {
    day: day,
    month: month,
    year: year
  };
};
export var validateDate = function validateDate(value) {
  var currentYear = new Date().getFullYear();
  var delta = 120;
  var date;

  if (isObject(value)) {
    date = value;
  } else {
    date = parseDate(value);
  }

  var _date = date,
      day = _date.day,
      month = _date.month,
      year = _date.year;
  var isNaN = Number.isNaN;
  if (isNaN(day) || isNaN(month) || isNaN(year)) return false;

  if (year < currentYear - delta || year > currentYear + delta) {
    return false;
  }

  if (month < 1 || month > 12) {
    return false;
  }

  return !(day < 1 || day > getDaysInMonth(month, year));
};
export var toDate = function toDate(value, noValidate) {
  if (isDate(value)) return value;
  if (isNumber(value)) return new Date(value);
  if (!isString(value)) return new Date();

  var _parseDate = parseDate(value),
      day = _parseDate.day,
      month = _parseDate.month,
      year = _parseDate.year;

  if (!noValidate && !validateDate({
    day: day,
    month: month,
    year: year
  })) {
    return new Date();
  }

  return new Date(year, month - 1, day);
};
export var formatDate = function formatDate(date) {
  if (isDate(date)) {
    var day = date.getDate();
    var month = date.getMonth() + 1;
    return "".concat(day < 10 ? "0".concat(day) : day, ".").concat(month < 10 ? "0".concat(month) : month, ".").concat(date.getFullYear());
  } // eslint-disable-next-line no-console


  console.warn("Error during date formatting. Expected \"Date\" type, but got \"".concat(getType(date), "\""));
  return null;
};
export var getIsToday = function getIsToday(date) {
  var today = new Date().setHours(0, 0, 0, 0);
  return date.setHours(0, 0, 0, 0) === today;
};
export var getTime = function getTime(value) {
  return toDate(value).getTime();
};
export var setHoursZero = function setHoursZero(date) {
  return date.setHours(0, 0, 0, 0);
};
export var getDateWithoutTime = function getDateWithoutTime(date) {
  var d = toDate(date);
  return new Date(setHoursZero(d));
}; // ====================== disabled checks ======================

export var checkIsDisabledDay = function checkIsDisabledDay(disabledDaysMap, day) {
  var value = getTime(day);

  if (value < disabledDaysMap.min || value > disabledDaysMap.max || disabledDaysMap.ranges.find(function (range) {
    return range.from <= value && range.to >= value;
  }) || disabledDaysMap.days.has(value)) {
    return true;
  }

  return false;
};
export var checkIsDisabledRange = function checkIsDisabledRange(map, _ref) {
  var fromDateValue = _ref.from,
      toDateValue = _ref.to;
  var from = isDate(fromDateValue) ? fromDateValue.getTime() : fromDateValue;
  var to = isDate(toDateValue) ? toDateValue.getTime() : toDateValue;
  var listDayTimestamps = Array.from(map.days);

  if (from <= map.min - MILLISECONDS_IN_DAY || to >= map.max + MILLISECONDS_IN_DAY || map.ranges.find(function (range) {
    return from > range.from && from < range.to || to > range.from && to < range.to || from < range.from && to > range.to;
  }) || listDayTimestamps.find(function (day) {
    return from < day && to > day;
  })) {
    return true;
  }

  return false;
}; // ====================== disabled days ======================

export var transformDisabledDayObject = function transformDisabledDayObject(value) {
  return Object.keys(value).reduce(function (acc, key) {
    acc[key] = toDate(value[key]);
    return acc;
  }, {});
};
export var transformDisabledDays = function transformDisabledDays(days) {
  if (isString(days) || isDate(days)) return toDate(days);
  if (isObject(days)) return transformDisabledDayObject(days);

  if (isArray(days)) {
    return days.map(transformDisabledDays);
  }

  return undefined;
};
export var getMonthTimestamp = function getMonthTimestamp(year, month) {
  return {
    min: new Date(year, month).getTime(),
    max: new Date(year, month + 1).getTime()
  };
};
export var getYearTimestamp = function getYearTimestamp(year) {
  return {
    min: new Date(year, 0).getTime(),
    max: new Date(year, 12, 0).getTime()
  };
};

var getDisabledTimestampsFromObject = function getDisabledTimestampsFromObject(obj, acc) {
  var map = {
    min: acc.min,
    max: acc.max
  };

  var keys = _toConsumableArray(new Set(Object.keys(obj)));

  keys.forEach(function (key) {
    if (key === 'before') {
      map.min = map.min && map.min > getTime(obj.before) ? map.min : getTime(obj.before);
    } else if (key === 'after') {
      map.max = map.max && map.max < getTime(obj.after) ? map.max : getTime(obj.after);
    } else if (key === 'from') {
      map.from = map.from && map.from < getTime(obj.from) ? map.from : getTime(obj.from);
    } else if (key === 'to') {
      map.to = map.to && map.to > getTime(obj.to) ? map.to : getTime(obj.to);
    }
  });
  var from = map.from,
      to = map.to,
      min = map.min,
      max = map.max;

  if (!from && to) {
    map.min = min && min > to ? min : to;
  } else if (!to && from) {
    map.max = max && max < from ? max : from;
  } else if (from && to) {
    return {
      min: min,
      max: max,
      ranges: [].concat(_toConsumableArray(acc.ranges), [{
        from: from,
        to: to
      }]),
      days: acc.days
    };
  }

  return {
    min: min,
    max: max,
    ranges: acc.ranges,
    days: acc.days
  };
};

export var getDisabledTimestamps = function getDisabledTimestamps(disabledDays) {
  var $disabledDays = transformDisabledDays(disabledDays);
  var result = {
    ranges: [],
    days: new Set()
  };

  if (isDate($disabledDays)) {
    result.days.add(getTime($disabledDays));
  } else if (isObject($disabledDays)) {
    result = getDisabledTimestampsFromObject($disabledDays, result);
  } else if (isArray($disabledDays)) {
    $disabledDays.forEach(function (x) {
      if (isDate(x)) result.days.add(x.getTime());
      if (isObject(x)) result = getDisabledTimestampsFromObject(x, result);
    });
  }

  return result;
};
var MONTHS_WITH_31_DAYS = [1, 3, 5, 7, 8, 10, 12];
var MONTHS_WITH_30_DAYS = [4, 6, 9, 11];
var FEBRUARY = 2;

var isLeapYear = function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};

var splitDateString = function splitDateString(dateString) {
  var carried = null;
  var parts = dateString.split('.', 3).map(function (part, i) {
    var datePart = carried ? "".concat(carried).concat(part) : part;

    if (i === 2) {
      carried = null;
      return datePart.slice(0, 4);
    }

    carried = datePart.slice(2);
    return datePart.slice(0, 2);
  });

  if (carried && parts.length < 3) {
    for (var i = parts.length - 1; i < 3; i += 1) {
      if (i === 2) {
        parts.push(carried.slice(0, 4));
      } else {
        carried = carried.slice(2);
        parts.push(carried.slice(0, 2));
      }
    }
  }

  return parts;
};

export var formatDateString = function formatDateString(dateString) {
  if (!dateString || !isString(dateString)) {
    return '';
  }

  var date = dateString.replace(/[^\d.]/g, '');

  if (!date) {
    return '';
  }

  var parts = splitDateString(dateString);

  var _parts = _slicedToArray(parts, 3),
      day = _parts[0],
      month = _parts[1],
      year = _parts[2];

  var dayNumber = parseInt(day, 10);

  if (year.length === 4 && year[0] === '0') {
    year = "2".concat(year.slice(1));
  }

  if (day === '00') {
    day = '01';
    dayNumber = 1;
  } else if (dayNumber > 31) {
    day = '31';
    dayNumber = 31;
  }

  if (month) {
    var monthNumber = parseInt(month, 10);

    if (month === '00') {
      month = '01';
      monthNumber = 1;
    } else if (monthNumber > 12) {
      month = '12';
      monthNumber = 12;
    }

    if (monthNumber === FEBRUARY) {
      var isLeap = !year || year.length < 4 || isLeapYear(parseInt(year, 10));

      if (isLeap && dayNumber > 29) {
        day = '29';
      } else if (!isLeap && dayNumber > 28) {
        day = '28';
      }
    } else if (MONTHS_WITH_31_DAYS.includes(monthNumber) && dayNumber > 31) {
      day = '31';
    } else if (MONTHS_WITH_30_DAYS.includes(monthNumber) && dayNumber > 30) {
      day = '30';
    }
  }

  return [day, month, year].filter(function (part) {
    return !!part;
  }).join('.');
};
var DATE_REGEXP = /^(?:0[1-9]|[1-2]\d|3[01])\.(?:0[1-9]|1[0-2])\.\d{4}$/;
export var validateDateString = function validateDateString(dateString) {
  return dateString && isString(dateString) && DATE_REGEXP.test(dateString);
};
export var getLastDayOfMonth = function getLastDayOfMonth(month) {
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getFullYear();

  if (month === FEBRUARY) {
    return isLeapYear(parseInt(year, 10)) ? 29 : 28;
  }

  if (MONTHS_WITH_31_DAYS.includes(month)) {
    return 31;
  }

  if (MONTHS_WITH_30_DAYS.includes(month)) {
    return 30;
  }

  return null;
};